import { createAction, props } from '@ngrx/store';
import { CandidateSearch } from '../models/candidate.model';

export const setCandidateSearch = createAction('[Candidates Component] SetCandidateSearch', props<CandidateSearch>());
